
export const chunkArray = (array, size) => {
  let chunked = []
  Array.from({length: Math.ceil(array.length / size)}, (val, i) => {
    chunked.push(array.slice(i * size, i * size + size))
  })
  return chunked;
}




